import { css } from "emotion";

export const closeIcon = css`
    font-size: 15px;
    line-height: 24px;
    text-align: center;
    width: 24px;
    height: 24px;
    position: absolute;
    right: 7px;
    top: 7px;
    border-radius: 50%;
    cursor: pointer;
    fill: #767676;

    &:hover {
        fill: #2d2d2d;
    }
`;

export const modalLayer = css`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin-right: -18px;
    padding-right: 18px;
    overflow-y: scroll;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 500;
`;

export const modalLayerHide = css`
    display: none;
    visibility: hidden;
`;

export const modalContainer = css`
    position: relative;
    max-width: 680px;
    height: auto;
    /* padding: 15px; */
    background-color: #fff;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
    margin: 20px auto;
`;
